<template>
  <div class="fill-grey p-24 d-flex align-items-center">
    <svg class="mr-24 d-none d-lg-block d-md-block" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M33.3332 14.9C33.3158 14.7469 33.2823 14.596 33.2332 14.45V14.3C33.153 14.1286 33.0461 13.9711 32.9165 13.8333L22.9165 3.83331C22.7787 3.70367 22.6212 3.59678 22.4498 3.51665H22.2832C22.1211 3.42998 21.9469 3.36818 21.7665 3.33331H11.6665C10.3404 3.33331 9.06865 3.8601 8.13097 4.79778C7.19329 5.73546 6.6665 7.00723 6.6665 8.33331V31.6666C6.6665 32.9927 7.19329 34.2645 8.13097 35.2022C9.06865 36.1399 10.3404 36.6666 11.6665 36.6666H28.3332C29.6593 36.6666 30.931 36.1399 31.8687 35.2022C32.8064 34.2645 33.3332 32.9927 33.3332 31.6666V15C33.3332 15 33.3332 15 33.3332 14.9ZM23.3332 9.01665L27.6498 13.3333H24.9998C24.5578 13.3333 24.1339 13.1577 23.8213 12.8452C23.5088 12.5326 23.3332 12.1087 23.3332 11.6666V9.01665ZM29.9998 31.6666C29.9998 32.1087 29.8242 32.5326 29.5117 32.8452C29.1991 33.1577 28.7752 33.3333 28.3332 33.3333H11.6665C11.2245 33.3333 10.8006 33.1577 10.488 32.8452C10.1754 32.5326 9.99984 32.1087 9.99984 31.6666V8.33331C9.99984 7.89129 10.1754 7.46736 10.488 7.1548C10.8006 6.84224 11.2245 6.66665 11.6665 6.66665H19.9998V11.6666C19.9998 12.9927 20.5266 14.2645 21.4643 15.2022C22.402 16.1399 23.6738 16.6666 24.9998 16.6666H29.9998V31.6666ZM22.1498 23.8166L21.6665 24.3166V20C21.6665 19.558 21.4909 19.134 21.1783 18.8215C20.8658 18.5089 20.4419 18.3333 19.9998 18.3333C19.5578 18.3333 19.1339 18.5089 18.8213 18.8215C18.5088 19.134 18.3332 19.558 18.3332 20V24.3166L17.8498 23.8166C17.536 23.5028 17.1103 23.3265 16.6665 23.3265C16.2227 23.3265 15.797 23.5028 15.4832 23.8166C15.1693 24.1305 14.993 24.5561 14.993 25C14.993 25.4438 15.1693 25.8695 15.4832 26.1833L18.8165 29.5166C18.975 29.6684 19.1619 29.7873 19.3665 29.8666C19.566 29.9548 19.7817 30.0004 19.9998 30.0004C20.218 30.0004 20.4337 29.9548 20.6332 29.8666C20.8378 29.7873 21.0247 29.6684 21.1832 29.5166L24.5165 26.1833C24.8303 25.8695 25.0067 25.4438 25.0067 25C25.0067 24.5561 24.8303 24.1305 24.5165 23.8166C24.2027 23.5028 23.777 23.3265 23.3332 23.3265C22.8893 23.3265 22.4637 23.5028 22.1498 23.8166Z" fill="#333333"/>
    </svg>
    <div class="attach row">
      <div class="col-md-6 d-flex align-items-center justify-content-star title-block">
        <template v-if="!value">
          <label v-html="title"></label>
        </template>
        <template v-else>
          <label>
            <a :href="value.file" target="_blank">
              <span v-html="title"></span>
            </a>
          </label>
        </template>
      </div>
      <div class="col-md-6 col-sm-12 d-flex align-items-center justify-content-end">
        <button v-show="file" type="button" @click="deleteFile" class="btn btn-outline-danger btn-outline-danger-with-icon mr-24 mb-0">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.94004 8L13.14 3.80667C13.2656 3.68113 13.3361 3.51087 13.3361 3.33333C13.3361 3.1558 13.2656 2.98554 13.14 2.86C13.0145 2.73447 12.8442 2.66394 12.6667 2.66394C12.4892 2.66394 12.3189 2.73447 12.1934 2.86L8.00004 7.06L3.80671 2.86C3.68117 2.73447 3.51091 2.66394 3.33337 2.66394C3.15584 2.66394 2.98558 2.73447 2.86004 2.86C2.7345 2.98554 2.66398 3.1558 2.66398 3.33333C2.66398 3.51087 2.7345 3.68113 2.86004 3.80667L7.06004 8L2.86004 12.1933C2.79756 12.2553 2.74796 12.329 2.71411 12.4103C2.68027 12.4915 2.66284 12.5787 2.66284 12.6667C2.66284 12.7547 2.68027 12.8418 2.71411 12.9231C2.74796 13.0043 2.79756 13.078 2.86004 13.14C2.92202 13.2025 2.99575 13.2521 3.07699 13.2859C3.15823 13.3198 3.24537 13.3372 3.33337 13.3372C3.42138 13.3372 3.50852 13.3198 3.58976 13.2859C3.671 13.2521 3.74473 13.2025 3.80671 13.14L8.00004 8.94L12.1934 13.14C12.2554 13.2025 12.3291 13.2521 12.4103 13.2859C12.4916 13.3198 12.5787 13.3372 12.6667 13.3372C12.7547 13.3372 12.8419 13.3198 12.9231 13.2859C13.0043 13.2521 13.0781 13.2025 13.14 13.14C13.2025 13.078 13.2521 13.0043 13.286 12.9231C13.3198 12.8418 13.3372 12.7547 13.3372 12.6667C13.3372 12.5787 13.3198 12.4915 13.286 12.4103C13.2521 12.329 13.2025 12.2553 13.14 12.1933L8.94004 8Z"/>
          </svg>
          Удалить
        </button>
        <label :for="id" class="btn btn-outline-primary btn-outline-primary-with-icon d-flex justify-content-between mb-0">
          <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.0533 8.27998L7.93328 12.4066C7.39315 12.8867 6.69004 13.1422 5.96776 13.1209C5.24548 13.0996 4.55861 12.8032 4.04766 12.2923C3.53671 11.7813 3.24028 11.0944 3.21902 10.3722C3.19776 9.64988 3.45327 8.94677 3.93328 8.40665L9.26661 3.07331C9.58503 2.77084 10.0074 2.6022 10.4466 2.6022C10.8858 2.6022 11.3082 2.77084 11.6266 3.07331C11.9368 3.38771 12.1108 3.81163 12.1108 4.25331C12.1108 4.695 11.9368 5.11892 11.6266 5.43331L7.02661 10.0266C6.98109 10.0757 6.92635 10.1153 6.86553 10.1431C6.80471 10.171 6.73899 10.1866 6.67213 10.1891C6.60528 10.1916 6.53858 10.1809 6.47587 10.1576C6.41315 10.1343 6.35564 10.0988 6.30661 10.0533C6.25758 10.0078 6.218 9.95305 6.19013 9.89223C6.16226 9.83141 6.14664 9.76569 6.14416 9.69883C6.14168 9.63198 6.1524 9.56529 6.1757 9.50257C6.199 9.43985 6.23442 9.38234 6.27994 9.33331L9.69994 5.91998C9.82548 5.79444 9.89601 5.62418 9.89601 5.44665C9.89601 5.26911 9.82548 5.09885 9.69994 4.97331C9.57441 4.84778 9.40415 4.77725 9.22661 4.77725C9.04908 4.77725 8.87881 4.84778 8.75328 4.97331L5.33328 8.39998C5.16215 8.56978 5.02632 8.77178 4.93363 8.99433C4.84094 9.21687 4.79322 9.45557 4.79322 9.69665C4.79322 9.93772 4.84094 10.1764 4.93363 10.399C5.02632 10.6215 5.16215 10.8235 5.33328 10.9933C5.68286 11.3263 6.14715 11.512 6.62994 11.512C7.11274 11.512 7.57703 11.3263 7.92661 10.9933L12.5199 6.39331C13.0499 5.82461 13.3384 5.07243 13.3246 4.29522C13.3109 3.51802 12.9961 2.77648 12.4464 2.22682C11.8968 1.67717 11.1552 1.36232 10.378 1.34861C9.60083 1.3349 8.84864 1.62339 8.27994 2.15331L2.94661 7.48664C2.22741 8.2832 1.8433 9.32655 1.8743 10.3993C1.9053 11.472 2.34903 12.4915 3.11304 13.2452C3.87704 13.9988 4.90239 14.4287 5.97547 14.4451C7.04854 14.4615 8.08657 14.0633 8.87328 13.3333L12.9999 9.21331C13.0621 9.15115 13.1114 9.07736 13.1451 8.99614C13.1787 8.91493 13.196 8.82788 13.196 8.73998C13.196 8.65207 13.1787 8.56503 13.1451 8.48381C13.1114 8.4026 13.0621 8.3288 12.9999 8.26665C12.9378 8.20449 12.864 8.15518 12.7828 8.12154C12.7016 8.0879 12.6145 8.07058 12.5266 8.07058C12.4387 8.07058 12.3517 8.0879 12.2704 8.12154C12.1892 8.15518 12.1154 8.20449 12.0533 8.26665V8.27998Z"/>
          </svg>
          Загрузить
        </label>
        <input :name="name" accept="application/msword, text/plain, application/pdf, image/*" :required="required" type="file" :id="id" @change="uploadFile" ref="file" hidden/>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "AttachFile",
  props: {
    title: {
      type: String,
      default: 'Загрузите файл'
    },
    id: {
      type: String,
      default: new Date().getTime().toString()
    },
    name: {
      type: String,
      default: 'name'
    },
    value: {
      type: Object,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      file: null
    }
  },
  mounted() {
    this.file = this.value
  },
  methods: {
    uploadFile() {
      let file = this.$refs.file.files[0];
      if(file) {
        const formData = new FormData();
        formData.append('binaryContent', file, file.name);
        formData.append('context', 'default')
        ApiService
            .postFormData(`attaches`, formData)
            .then(async (res) => {
              if(res.status === 201) {
                this.updateValue(res.data.media)
              }
            })
      }
    },
    deleteFile() {
      this.updateValue(null)
    },
    updateValue(data) {
      this.$emit('input', data)
      this.file = data
    }
  },
}
</script>

<style lang="scss">
.attach {
  label {
    margin-bottom: 0!important;
  }
  @media (max-width: 768px){
    .title-block {
      margin-bottom: 10px;
    }
  }
}
</style>